import type { ReactNode } from 'react';
import { useIsClient } from '../utils/use-is-client';

export function ClientOnly({ children, fallback }: { children: ReactNode; fallback?: ReactNode }) {
  const isClient = useIsClient();
  return isClient ? children : (fallback ?? null);
}
